import {
  GetCollaboratorCmSheetGoalsResponse,
  UpdateCollaboratorCmSheetGoalsRequest,
} from "../../../types/api/collaborators.type";
import httpClient from "../../client/HttpClient";

const CmSheetGoalsService = {
  async get(cmSheetId: number): Promise<GetCollaboratorCmSheetGoalsResponse> {
    const response = await httpClient.get<GetCollaboratorCmSheetGoalsResponse>(
      `v1/cm-sheets/${cmSheetId}/goals`,
    );
    return response;
  },
  async update(
    cmSheetId: number,
    body: UpdateCollaboratorCmSheetGoalsRequest,
  ): Promise<void> {
    await httpClient.patch(`v1/cm-sheets/${cmSheetId}/goals`, body);
  },
};

export default CmSheetGoalsService;
